import MembraneImageLayout from "./MembraneImageLayout";
import ErrorIcon from '@material-ui/icons/Error';
import { useStore } from 'react-redux';
import { useState } from 'react';
import G from './Getters';
import CollapsibleSection from './CollapsibleSection';


import DemoGels from './DemoGels';
import { getMembranePercentWidth } from './SupplementReplicateContainer';


export default function SupplementCropReplicate({
  membrane, 
  toHighlight, 
  onEvent,
  expandMembrane,
  maxMembraneWidth,
}){

  const store = useStore();
  const state = store.getState();


  const [ showWarnings, setShowWarnigns ] = useState(false);

  const [ expand, setExpand ] = useState();

  debugger;

  let structure = DemoGels[membrane] || [];

  maxMembraneWidth = maxMembraneWidth || getMembranePercentWidth([membrane]) 

  


  let labelMap = Object.fromEntries(structure.flat().map(imageSetId => {

    let atns = G.getAnnotationsByImageSetId(state,imageSetId);
    let label = atns.find(x => x.ls)?.label;

    return [imageSetId,label]

  }))

  let warnings = [];

  if( !Object.values(labelMap).find(x => x.includes("actin")) ){
    //warnings.push("Replicate missing loading control.");
  }

  let warningComp = (
    <div class="sg-row v-center">

      <ErrorIcon style={{color:'#bf0000'}}/>
        &nbsp;

    <div style={{
        outline:'3px solid #bf0000',
        borderRadius:5,
        padding:5,
      }}>
        {warnings.map(ww => {
          return <div>{ww}</div>
        })}
      </div>

    </div>

  )
      

  return (
    <div>
      {warnings.length > 0 && warningComp}

      <MembraneImageLayout {...{expandMembrane,structure,toHighlight,onEvent, maxMembraneWidth}}/>
      
    </div>
  )


}
